const Throttle = function(delay, action) {
    let last = 0;
    
    return function() {
        let now = new Date().getTime();

        if(now - last > delay) {
            last = now
            action.apply(this, arguments)
        }
    };
};

export {
    Throttle,
} 